import { SystemOsType } from '@enums/system-os-type.enum';
import { Icon, ToolTip } from '@testsigma/atoms';
import classNames from 'classnames';

interface HybridOSTypeProps {
  osType: SystemOsType;
  osVersion: string;
  className?: string;
  variant?: 'detail' | 'concise';
  tooltipPlacement?: any;
}

const hybridOSIconMapping = {
  [SystemOsType.WINDOWS]: 'windows',
  [SystemOsType.MACOSX]: 'ios',
  [SystemOsType.LINUX]: 'linux',
  [SystemOsType.ANDROID]: 'real-mobile',
  [SystemOsType.IOS]: 'real-mobile',
};

export const HybridOSType: React.FC<HybridOSTypeProps> = ({
  osType,
  osVersion,
  className,
  variant = 'concise',
  tooltipPlacement,
}) => {
  return (
    <ToolTip
      placement={tooltipPlacement}
      content={`${osType} ${osVersion}`}
      align='center'
    >
      <span className={classNames('flex flex-row items-center', className)}>
        <Icon
          className={classNames(
            'text-secondary-400 group-hover:text-secondary-unique-800 hover:text-secondary-unique-800 text-base',
            {
              'leading-5': variant == 'concise',
            },
          )}
          name={hybridOSIconMapping[osType]}
        />
        {variant === 'detail' && (
          <span className='ml-2 truncate'>{'V.' + osVersion}</span>
        )}
      </span>
    </ToolTip>
  );
};
